import { UserRevision } from '../../core/entities/UserRevision';
import { IGetUserRevisionUseCase } from '../../core/usecases/cms/GetUserRevisionUseCase';
import { container } from '../../DataDomain';
import { DI } from '@intigral/constant/config/DIContainer';

export interface IUserRevisionService {
    getUserRevision(bucketId: number): Promise<UserRevision>;
}

export class UserRevisionService implements IUserRevisionService {
    // Lazy getter for dependency to avoid circular dependencies
    private get getUserRevisionUseCase(): IGetUserRevisionUseCase {
        return container.resolve<IGetUserRevisionUseCase>(DI.USECASES.IGetUserRevisionUseCase);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }

    async getUserRevision(bucketId: number): Promise<UserRevision> {
        const userRevision = await this.getUserRevisionUseCase.execute(bucketId);

        return userRevision;
    }
}
